document.addEventListener('DOMContentLoaded', function () {

  /* -----------------------------
     SWATCH CLICK -> UPDATE SELECT
  ----------------------------- */
  document.addEventListener('click', function (e) {

    const option = e.target.closest('.related-product-list .swatches-option');
    if (!option) return;

    const optionName = option.getAttribute('data-value');
    const itemBox = option.closest('.swatches-item-box');

    if (itemBox) {
      itemBox.querySelectorAll('.swatches-option').forEach(el => {
        el.classList.remove('selected');
      });
    }

    option.classList.add('selected');

    const swatchesBlock = option.closest('.swatches-block');
    if (!swatchesBlock) return;

    const select = swatchesBlock.querySelector('select');
    if (!select) return;

    select.value = optionName;
    select.dispatchEvent(new Event('change', { bubbles: true }));

  });


  /* -----------------------------
     VARIANT CHANGE (FIXED PROPERLY)
  ----------------------------- */
  document.addEventListener('change', function (e) {
  const selectEl = e.target.closest('.related-product-list .swatches-block select');
  if (!selectEl) return;
  const parent = selectEl.closest('.related_product_item');
  if (!parent) return;
  const masterSelect = parent.querySelector('.product-form__master-select');
  if (!masterSelect) return;

  // ✅ FIXED: get values from selected LI (UI)
  const selectedOptions = [];
  parent.querySelectorAll('.swatches-block').forEach(block => {
    const selectedLi = block.querySelector('.swatches-option.selected');
    if (selectedLi) {
      selectedOptions.push(
        selectedLi.getAttribute('data-value').trim()
      );
    }
  });
  if (!selectedOptions.length) return;
  let matchedOption = null;
  masterSelect.querySelectorAll('option').forEach(option => {
    const sku = option.getAttribute('data-sku');
    console.log('OPTION:', option);
    console.log('SKU:', sku);
    if (!sku) return;
    const variantOptions = sku.split(' / ');
    let isMatch = true;
    // 🔥 match by position (IMPORTANT)
    for (let i = 0; i < selectedOptions.length; i++) {
        const selectedVal = selectedOptions[i];
        const variantVal = variantOptions[i] || '';
        console.log('INDEX:', i);
        console.log('SELECTED:', selectedVal);
        console.log('VARIANT:', variantVal);
        if (selectedVal !== variantVal) {
          isMatch = false;
          break;
        }
      }
        if (isMatch) {
          matchedOption = option;
      }
    });

  if (!matchedOption) {
    console.log('❌ No variant match:', selectedOptions);
    return;
  }

  const variantId = matchedOption.value;
  let price = matchedOption.getAttribute('data-price');
  if (!price) {
    const optionText = matchedOption.textContent || '';
    price = optionText.split(' - ')[1];
  }
  const available =
    matchedOption.getAttribute('data-variant-availability') === 'true';
  if (masterSelect.value !== variantId) {
    masterSelect.value = variantId;
  }
  const priceEl = parent.querySelector('.related_product__price');
  if (priceEl && price) {
    priceEl.textContent = price;
  }
  const addBtn = parent.querySelector('.fbt_btn_add');
  const btnText = addBtn?.querySelector('span');
  if (!addBtn) return;
  addBtn.setAttribute('data-id', variantId);
  if (available) {
    addBtn.classList.add('add');
    addBtn.classList.remove('soldout');
    if (btnText) btnText.textContent = 'Add';
  } else {
    addBtn.classList.add('soldout');
    addBtn.classList.remove('add');
    if (btnText) btnText.textContent = 'Sold out';
  }
});


  /* -----------------------------
     ADD TO CART (NO CHANGE)
  ----------------------------- */
  document.addEventListener('click', function (e) {

  const btn = e.target.closest('.related-product-list .fbt_btn_add');
  if (!btn) return;

  if (btn.classList.contains('soldout')) return;

  const variantId = btn.getAttribute('data-id');

  if (!variantId) return;

  const items = [
    {
      id: variantId,
      quantity: 1
    }
  ];

  btn.classList.add('is-loading');

  const spinner = btn.querySelector('.loading-overlay__spinner');
  if (spinner) spinner.classList.remove('hidden');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      items: items,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    })
  })
    .then(res => res.json())
    .then((data) => {

      btn.classList.remove('is-loading');
      if (spinner) spinner.classList.add('hidden');

      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;

      if (cartDrawer.renderContents) {
        cartDrawer.renderContents(data);
        cartDrawer.open();
        cartDrawer.classList.remove('is-empty');
      } else {
        document.body.classList.add('overflow-hidden');
        cartDrawer.classList.add('active');
      }

    })
    .catch(() => {
      btn.classList.remove('is-loading');
      if (spinner) spinner.classList.add('hidden');
    });

});

  // Cart Bumper code

   /* -----------------------------
   SWATCH CLICK
  ----------------------------- */
  document.addEventListener('click', function (e) {
    const option = e.target.closest('.cart_related_products .swatches-option');
    if (!option) return;
    const optionName = option.getAttribute('data-value');
    const itemBox = option.closest('.swatches-item-box');
    if (itemBox) {
      itemBox.querySelectorAll('.swatches-option').forEach(el => el.classList.remove('selected'));
    }
    option.classList.add('selected');
    const swatchesBlock = option.closest('.swatches-block');
    if (!swatchesBlock) return;
    const select = swatchesBlock.querySelector('select');
    if (!select) return;
    select.value = optionName;
    select.dispatchEvent(new Event('change', { bubbles: true }));

  });

  // CLOSE BUTTON → hide bumper
  document.addEventListener('click', function (e) {
    const closeBtn = e.target.closest('.closeBtn');
    if (!closeBtn) return;

    const bumper = document.querySelector('.cart_related_products.bumper_product');
    if (bumper) {
      bumper.classList.add('hidden');
    }
  });


  /* -----------------------------
    VARIANT CHANGE
  ----------------------------- */
  document.addEventListener('change', function (e) {

    const selectEl = e.target.closest('.cart_related_products .swatches-block select');
    if (!selectEl) return;

    const parent = selectEl.closest('.product_item');
    if (!parent) return;

    const masterSelect = parent.querySelector('.product-form__master-select');
    if (!masterSelect) return;

    // Get selected options from UI
    const selectedOptions = [];
    parent.querySelectorAll('.swatches-block').forEach(block => {
      const selectedLi = block.querySelector('.swatches-option.selected');
      if (selectedLi) selectedOptions.push(selectedLi.getAttribute('data-value').trim());
    });

    if (!selectedOptions.length) return;

    let matchedOption = null;
    masterSelect.querySelectorAll('option').forEach(option => {
      const sku = option.getAttribute('data-sku');
      if (!sku) return;

      const variantOptions = sku.split(' / ');
      let isMatch = true;
      for (let i = 0; i < selectedOptions.length; i++) {
        if (selectedOptions[i] !== (variantOptions[i] || '')) {
          isMatch = false;
          break;
        }
      }
      if (isMatch) matchedOption = option;
    });

    if (!matchedOption) return;

    const variantId = matchedOption.value;
    let price = matchedOption.getAttribute('data-price') || matchedOption.textContent.split(' - ')[1];
    const available = matchedOption.getAttribute('data-variant-availability') === 'true';

    if (masterSelect.value !== variantId) masterSelect.value = variantId;

    const addBtn = parent.querySelector('.fbt_btn_add');
    const btnText = addBtn?.querySelector('span');
    if (!addBtn) return;
    
    addBtn.setAttribute('data-id', variantId);

    if (available) {
      addBtn.classList.add('add');
      addBtn.classList.remove('soldout');
      if (btnText) btnText.textContent = 'Add';
      addBtn.removeAttribute('disabled');
    } else {
      addBtn.classList.add('soldout');
      addBtn.classList.remove('add');
      if (btnText) btnText.textContent = 'Sold out';
      addBtn.setAttribute('disabled', '');
    }

  });


  /* -----------------------------
    ADD TO CART (BUMPER)
  ----------------------------- */
  document.addEventListener('click', function (e) {

    const btn = e.target.closest('.cart_related_products .fbt_btn_add');
    if (!btn) return;

    // ✅ Prevent any native form submission / default behavior
    e.preventDefault();

    if (btn.classList.contains('soldout')) return;

    const items = [];

    document.querySelectorAll('.cart_related_products .product_item').forEach(item => {
      const addBtn = item.querySelector('.fbt_btn_add');
      if (!addBtn || addBtn.classList.contains('soldout')) return;
      const id = addBtn.getAttribute('data-id');
      if (!id) return;
      items.push({ id: id, quantity: 1 });
    });

    if (!items.length) return;

    btn.classList.add('is-loading');
    const spinner = btn.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.remove('hidden');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
    .then(res => res.json())
    .then(data => {
      btn.classList.remove('is-loading');
      if (spinner) spinner.classList.add('hidden');

      // Remove bumper
      const bumper = document.querySelector('.cart_related_products');
      if (bumper) bumper.remove();

      // Update cart drawer silently
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && cartDrawer.renderContents) {
        cartDrawer.renderContents(data);
        cartDrawer.classList.remove('is-empty');
      }

      // Update cart icon/bubble
      const cartIconBubble = document.querySelector('.cart-icon-bubble');
      if (cartIconBubble && data.item_count !== undefined) {
        cartIconBubble.textContent = data.item_count;
      }

    })
    .catch(() => {
      btn.classList.remove('is-loading');
      if (spinner) spinner.classList.add('hidden');
    });

  });
  
  // product page readmore or read less
    document.addEventListener("click", function(e){
    const btn = e.target.closest(".read-more-btn");
    if(!btn) return;

    const wrapper = btn.closest(".product-description-wrapper");
    if(!wrapper) return;

    const text = wrapper.querySelector(".description-content");
    if(!text) return;

    text.classList.toggle("expanded");

    btn.textContent = text.classList.contains("expanded")
      ? "Read less"
      : "Read more";
  });
});